export default __webpack_public_path__ + "7cdc313057732181b432156414f4d9c9.png";